(() => {
  const selector = '[data-pa-delivery-date]';
  const fallbackBankHolidays = new Set([
    '2026-01-01', '2026-01-02', '2026-03-17', '2026-04-03', '2026-04-06',
    '2026-05-04', '2026-05-25', '2026-06-15', '2026-07-13', '2026-08-03',
    '2026-08-31', '2026-11-30', '2026-12-25', '2026-12-28',
    '2027-01-01', '2027-01-04', '2027-03-17', '2027-03-26', '2027-03-29',
    '2027-05-03', '2027-05-31', '2027-07-12', '2027-08-02', '2027-08-30',
    '2027-11-30', '2027-12-27', '2027-12-28',
    '2028-01-03', '2028-01-04', '2028-03-17', '2028-04-14', '2028-04-17',
    '2028-05-01', '2028-05-29', '2028-07-12', '2028-08-07', '2028-08-28',
    '2028-11-30', '2028-12-25', '2028-12-26'
  ]);
  let bankHolidays = fallbackBankHolidays;

  const dateKey = (date) => date.toISOString().slice(0, 10);

  const londonToday = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
    return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
  };

  const estimatedDate = () => {
    const date = londonToday();
    let workingDays = 0;

    while (workingDays < 3) {
      date.setUTCDate(date.getUTCDate() + 1);
      const day = date.getUTCDay();
      if (day !== 0 && day !== 6 && !bankHolidays.has(dateKey(date))) {
        workingDays += 1;
      }
    }

    return date;
  };

  const renderDates = (root = document) => {
    const dates = [];
    if (root instanceof Element && root.matches(selector)) dates.push(root);
    if (root.querySelectorAll) dates.push(...root.querySelectorAll(selector));

    if (dates.length === 0) return;

    const date = estimatedDate();
    const label = new Intl.DateTimeFormat('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      timeZone: 'UTC'
    }).format(date);

    dates.forEach((time) => {
      time.dateTime = dateKey(date);
      time.textContent = label;
      time.hidden = false;
      const prefix = time.parentElement?.querySelector('[data-pa-delivery-date-prefix]');
      if (prefix) prefix.hidden = false;
    });
  };

  const loadBankHolidays = async () => {
    try {
      const response = await fetch('https://www.gov.uk/bank-holidays.json', {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const data = await response.json();
      const dates = Object.values(data)
        .flatMap((division) => division.events || [])
        .map((event) => event.date)
        .filter(Boolean);
      if (dates.length > 0) {
        bankHolidays = new Set(dates);
        renderDates();
      }
    } catch (error) {
      return;
    }
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) renderDates(node);
      });
    });
  });

  const start = () => {
    renderDates();
    observer.observe(document.body, { childList: true, subtree: true });
    loadBankHolidays();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
